import * as React from 'react';
import { useSelector } from 'react-redux';
import { BreadCrumbs as BreadCrumbsComponent } from '../../components/BreadCrumbs';
import { getBreadcrumbs } from '../../selectors/newbuilding';

export function BreadCrumbs() {
  const breadcrumbs = useSelector(getBreadcrumbs);

  return <BreadCrumbsComponent breadcrumbs={breadcrumbs} />;
}
